module.exports = __webpack_public_path__ + "img/main03_sys.5bb25eee.jpg";